export function cn(...args: (string | undefined | false | null | Record<string, boolean>)[]): string {
    const classes: string[] = []

    for (const arg of args) {
        if (!arg) continue

        if (typeof arg === 'string') {
            classes.push(arg)
        } else if (typeof arg === 'object' && !Array.isArray(arg)) {
            for (const [key, value] of Object.entries(arg)) {
                if (value) classes.push(key)
            }
        }
    }

    return classes.join(' ')
}